import styled from 'styled-components'

import { icons } from '@/constants/icons'

export const Wrapper = styled.div<{ $isExpired: boolean }>`
  position: relative;
  width: 832px;
  height: 320px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto 62px;
  margin-top: ${(props) => (props.$isExpired ? '0' : '150px')};
`

export const TvImage = styled.div<{ $isError: boolean }>`
  position: relative;
  width: 488px;
  height: 320px;
  padding-top: 130px;
  background-image: url(${icons.register.tvImg});
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
  &:after {
    content: '';
    display: ${(props) => (props.$isError ? 'block' : 'none')};
    position: absolute;
    top: 9px;
    left: 9px;
    width: 470px;
    height: 262px;
    background-color: rgba(206, 43, 121, 0.4);
    background-image: url(${icons.register.errorIcon});
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 89px 89px;
  }
`
export const ConnectImage = styled.div<{ $isError: boolean }>`
  position: relative;
  width: 127px;
  height: 55px;
  background-image: ${(props) =>
    props.$isError
      ? `url(${icons.register.connectError})`
      : `url(${icons.register.lineConnect})`};
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
`
export const MobileImage = styled.div<{ $isOpacity: boolean }>`
  width: 119px;
  height: 236px;
  background-image: url(${icons.register.mobileImg});
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
  opacity: ${(props) => (props.$isOpacity ? 0.2 : 1)};
`
export const DoneImage = styled('div')`
  position: absolute;
  top: -60px;
  left: 30px;
  width: 64px;
  height: 64px;
  background-image: url(${icons.register.doneIcon});
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
`
